import * as moment from 'moment';

import { msRecurrencePattern, RecurrenceDto } from './ms_recurrence';

// utilizado para criação do evento
export class SchedulingDto {
    calendar_id: string;
    checklist_name: string;

    startTime: string | Date | moment.Moment;
    endTime: string | Date | moment.Moment;
    recurrence: RecurrenceDto;

    // implement
    attendees: any[];
    categories: string[];

    // from ms
    date: string | Date | moment.Moment;

    // origin
    origin: string;

    // sut
    // user_name?: string;
    // user_email?: string;
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/ms_scheduling_dto.ts